import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  templateUrl: './lists.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListsComponent {}
